import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import templateContent from "./construction-site-actions.html";

import followUpManager from "../../_shark_jaws/managers/followUpManager";
import { constructionSiteManager } from "../../_shark_jaws/managers/constructionSiteManager";
import disableActionButtonComponent from "../disableActionButton/disableActionButtonComponen";
import { documentManager } from "../../_shark_jaws/managers/documentManager";
import { folderManager } from "../../_shark_jaws/managers/folderManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";
import ConstructionSite from "../../_shark_models/ConstructionSite";
import Document from "../../_shark_models/Document";

class ConstructionSiteActionsComponent extends Component {
	constructor(name) {
		super(name);

		this.addTemplate("", templateContent);
	}

	afterRender () {
		if (this.get("open")) {
			$("#constructionSiteActionsModal").modal("show");
		}
	}
	
	close () {
		$(`#constructionSiteActionsModal`).modal("hide");
		
		const body = document.querySelector("body");
		body.classList.remove("wait-box-open");
		body.classList.remove("modal-open");
		body.style.removeProperty("padding-right");

		this.set("open", false);
	}

	constructionSiteActionsModalCancelBtn_clickHandler () {
		this.hide();
	}
	
	constructionSiteActionsModalConfirmBtn_clickHandler (event) {
		if (this.isFormValid()) {
			const { currConstructionSiteTeamCloseDocument } = Shark.get();

			if (currConstructionSiteTeamCloseDocument.document != null && currConstructionSiteTeamCloseDocument.fileName !== "") {
				if (confirm("Vuoi davvero impostare il Cantiere come 'Concluso'?\nSe prosegui non potrai annullare l'operazione!")) {
					this.saveDocumentAndConstructionSite();
				}
			}
			else {
				if (confirm("Non hai inserito un documento di chiusura, il Cantiere verrà impostato come 'Chiuso'.\n\nVuoi davvero impostare il Cantiere come 'Chiuso'?\nSe prosegui non potrai annullare l'operazione!")) {
					// this.saveDocumentAndConstructionSite();
					this.saveConstructionSiteAsClosed();
				}
			}
		}
		else {
			disableActionButtonComponent.resetStatus(event.target);
		}
	}
	
	constructionSiteActionsModalConfirmTeamCloseDocumentBtn_clickHandler (event) {
		if (this.isFormValid()) {
			this.saveDocumentAndConstructionSite();
		}
		else {
			disableActionButtonComponent.resetStatus(event.target);
		}
	}
	
	constructionSiteActionsModalSendTeamCloseDocumentBtn_clickHandler () {
		document.querySelector("#uploadedConstructionSiteAttachment").click();
	}
	
	hide () {
		this.close();
	}
	
	init () {
		this.addComponents([disableActionButtonComponent, waitBoxComponent]);

		const currConstructionSiteTeamCloseDocument = Shark.getInstance("__smart__", {
			document: null,
			fileName: "",
			preservePreviousFile: true,
			replaceNotes: "",
			__replaceNotesErrorCSSClass: "",
		});
	
		Shark.set({currConstructionSiteTeamCloseDocument});
	
		this.set({
			open: false,
			__showEditOptions: false,
			__showWaitingConstructionSiteCardActions: false,
		});
	}

	//Dave: Bisogna inserire della validazione
	isFormValid () {
		if (this.$store.__openMode === "replaceTeamCloseDocument") {
			const { currConstructionSiteTeamCloseDocument } = Shark.get();

			if (currConstructionSiteTeamCloseDocument.replaceNotes.trim() === "") {
				currConstructionSiteTeamCloseDocument.set({
					__replaceNotesErrorCSSClass: "is-invalid",
				});
				Shark.render();
				return false;
			}

			return true;
		}
		else {
			return true;
		}
	}

	resetDocumentStatus () {
		const { currConstructionSiteTeamCloseDocument } = Shark.get();
		currConstructionSiteTeamCloseDocument.set({
			document: null,
			fileName: "",
			preservePreviousFile: true,
			replaceNotes: "",
			__replaceNotesErrorCSSClass: "",
		});
	}

	// Dave.ToDo: Qui c'è parecchio da rimettere in ordine, spostano azioni lato API e unificando.
	saveConstructionSiteAsClosed () {
		waitBoxComponent.show();
		const { currConstructionSite } = Shark.get();

		currConstructionSite.__closeComment = currConstructionSite.extraData.closeNotes;
		currConstructionSite.__confirmedClosingDate = currConstructionSite.__endDate;

		//Dave.Warn: Non va bene, non posso usarla così com'è perché se no fa partire la mail per Paola.... di la devo controllare se è una chiusura lato IPM CON documento, non devo mandare la mail
		constructionSiteManager.confirmClosing(currConstructionSite)
		.then(() => {
			document.querySelector("#uploadedConstructionSiteAttachment").dataset.saveName = Shark.__generateGUID();
			this.close();
			waitBoxComponent.close();
			//Dave.Warn: dopo questa operazione non sembra refresharsi lo stato del cantiere appena chiuso
			if (typeof Shark.activePage.refreshList === "function") {
				Shark.activePage.refreshList();
			}
			else {
				Shark.render();
			}
		});
	}
	
	saveDocumentAndConstructionSite () {
		waitBoxComponent.show();

		const { currConstructionSite, currConstructionSiteTeamCloseDocument } = Shark.get();
		const previousStatus = currConstructionSite.status;
		const newDocument = currConstructionSiteTeamCloseDocument.document;

		documentManager.save2([newDocument])
		.then(() => {
			if ([ConstructionSite.STATUS_OPEN, ConstructionSite.STATUS_NCR_RUNNING].includes(previousStatus)) {
				//Dave: Qui impostavo lo stato sempre a 3.. in teoria, però Se parto da un 4 non dovrei andare a 3... ma può succedere?
				currConstructionSite.import({
					teamCloseDocumentGuid: newDocument.guid,
				});

				currConstructionSite.__closeComment = currConstructionSite.extraData.closeNotes;
				currConstructionSite.__confirmedClosingDate = currConstructionSite.__endDate;

				//Dave.Warn: Non va bene, non posso usarla così com'è perché se no fa partire la mail per Paola.... di la devo controllare se è una chiusura lato IPM CON documento, non devo mandare la mail
				constructionSiteManager.confirmClosing(currConstructionSite)
				.then(() => {
					document.querySelector("#uploadedConstructionSiteAttachment").dataset.saveName = Shark.__generateGUID();
					this.close();
					waitBoxComponent.close();
					//Dave.Warn: dopo questa operazione non sembra refresharsi lo stato del cantiere appena chiuso
					if (typeof Shark.activePage.refreshList === "function") {
						Shark.activePage.refreshList();
					}
					else {
						Shark.render();
					}
				});
			}
			else {
				let newStatus = currConstructionSite.status;
				let previuosDocumentGuid = currConstructionSite.teamCloseDocumentGuid;

				// Dave:Info: Se sto sostituendo il Documento di chiusura non devo cambiare lo status.
				if (this.$store.__openMode !== "replaceTeamCloseDocument") {
					if ([ConstructionSite.STATUS_ENDED_OK].includes(currConstructionSite.status)) {
						newStatus = ConstructionSite.STATUS_CLOSED_OK;
					}
					else if ([ConstructionSite.STATUS_ENDED_NCR].includes(currConstructionSite.status)) {
						newStatus = ConstructionSite.STATUS_CLOSED_NCR;
					}
					else {
						newStatus = ConstructionSite.STATUS_NCR_CLOSED;
					}
				}
				// static STATUS_OPEN = 1;
				// static STATUS_ENDED_OK = 2;
				// static STATUS_CLOSED_OK = 3;
				// static STATUS_CLOSED_NCR = 4;
				// static STATUS_ENDED_NCR = 5;
				// static STATUS_NCR_RUNNING = 6;
				// static STATUS_NCR_ENDED = 7;
				// static STATUS_NCR_CLOSED = 8;

				currConstructionSite.import({
					status: newStatus,
					teamCloseDocumentGuid: newDocument.guid,
				});

				//Dave.ToDo: Questo dovrebbe usare l'apposito metodo confirm_closing_remote sulle API, perché triggera tutto il giro di eMail e roba varia.
				constructionSiteManager.save(currConstructionSite)
				.then(constructionSiteSaveResponse => {
					console.log({constructionSiteSaveResponse, currConstructionSite});
					let followUpBody;
					const lotReference = currConstructionSite.__lotId > -1 ? " per il lotto #" + (currConstructionSite.__lotId + 1) : "";

					followUpBody = `Aggiunto il Documento di Chiusura Fiscale${lotReference}.` ;
					
					const { currConstructionSiteTeamCloseDocument } = Shark.get();

					if (this.$store.__openMode === "replaceTeamCloseDocument") {
						followUpBody = `Sostituito il Documento di Chiusura Fiscale${lotReference}. È stata aggiunta la seguente motivazione: "<span data-role="user-reason">${currConstructionSiteTeamCloseDocument.replaceNotes.trim()}</span>"` ;
					}

					const newFollowUp = Shark.getInstance("ClientFollowUp", {
						body: followUpBody,
						clientGuid: currConstructionSite.clientGuid,
						referenceGuid: currConstructionSite.guid,
						referenceType: "constructionSite",
						status: 3,
						type: "system"
					});
					// console.log(newFollowUp);

					followUpManager.save(newFollowUp)
					.then(sharkResponse => {
						console.log({sharkResponse});
					});

					if (currConstructionSiteTeamCloseDocument.preservePreviousFile) {
						documentManager.setStatusByGuid(previuosDocumentGuid, Document.STATUS_EXPIRED);
					}
					else {
						documentManager.delete2([{guid: previuosDocumentGuid}]);
					}

					document.querySelector("#uploadedConstructionSiteAttachment").dataset.saveName = Shark.__generateGUID();
					this.hide();
					waitBoxComponent.hide();
					//Dave.Warn: dopo questa operazione non sembra refresharsi lo stato del cantiere appena chiuso
					if (typeof Shark.activePage.refreshList === "function") {
						Shark.activePage.refreshList();
					}
					else {
						Shark.render();
					}
				});
			}
			// return;

			// //Dave.ToDo: Questo dovrebbe usare l'apposito metodo confirm_closing_remote sulle API, perché triggera tutto il giro di eMail e roba varia.
			// constructionSiteManager.save(currConstructionSite)
			// .then(constructionSiteSaveResponse => {
			// 	console.log({constructionSiteSaveResponse, currConstructionSite});
			// 	let followUpBody;
			// 	const lotReference = currConstructionSite.__lotId > -1 ? " per il lotto #" + (currConstructionSite.__lotId + 1) : "";

			// 	if (previousStatus === ConstructionSite.STATUS_OPEN || previousStatus === ConstructionSite.STATUS_NCR_RUNNING) {
			// 		followUpBody = `Impostato il Cantiere ${lotReference} come concluso in data <strong>${currConstructionSite.__endDateLabel}</strong> ed aggiunto il documento di chiusura fiscale.${currConstructionSite.extraData.closeNotes !== "" ? " È stata aggiunta la seguente nota: '" + currConstructionSite.extraData.closeNotes + "'." : ""}`;
			// 	}
			// 	else {
			// 		followUpBody = `Aggiunto il documento di chiusura fiscale${lotReference}.` ;
			// 	}

			// 	const newFollowUp = Shark.getInstance("ClientFollowUp", {
			// 		body: followUpBody,
			// 		clientGuid: currConstructionSite.clientGuid,
			// 		referenceGuid: currConstructionSite.guid,
			// 		referenceType: "constructionSite",
			// 		status: 3,
			// 		type: "system"
			// 	});
			// 	console.log(newFollowUp);

			// 	followUpManager.save(newFollowUp)
			// 	.then(sharkResponse => {
			// 		console.log({sharkResponse});
			// 	});

			// 	document.querySelector("#uploadedConstructionSiteAttachment").dataset.saveName = Shark.__generateGUID();
			// 	this.hide();
			// 	waitBoxComponent.hide();
			// 	//Dave.Warn: dopo questa operazione non sembra refresharsi lo stato del cantiere appena chiuso
			// 	Shark.render();
			// });
		});
	}

	show (mode = "closeAndSend") {
		const currConstructionSite = Shark.get("currConstructionSite");

		this.set({
			__nextConstructionSiteAttachmentSaveName: Shark.__generateGUID(),
			__openMode: mode,
			__showCloseForm: mode === "closeAndSend",
			__showEditOptions: currConstructionSite.extraData.quotationCCA === "" && currConstructionSite.status === 1,
			__showReplaceTeamCloseDocumentWarning: ["replaceTeamCloseDocument"].includes(mode),
			__showSendTeamCloseDocumentForm: ["replaceTeamCloseDocument", "sendTeamCloseDocument"].includes(mode),
			__showWaitingConstructionSiteCardActions: currConstructionSite.extraData.quotationCCA !== "" && currConstructionSite.status === 1,
			__todayISO: moment().format(Shark.get("dtIsoDate"))
		});
		
		this.resetDocumentStatus();

		Shark.render();
		$(`#constructionSiteActionsModal`).modal("show");

		this.set("open", true);
	}

	uploadedConstructionSiteAttachment_changeHandler (event) {
		if (event.target.files.length === 0) {
			return;
		}
	
		waitBoxComponent.show();
	
		//Dave: Non sarebbe più sensato prima verificare la cartella e poi mandare il file?
		documentManager.upload(event.target)
		.then(uploadDocumentResponse => {
			const uploadedDocument = uploadDocumentResponse.data.documents[0];
			const currConstructionSite = Shark.get("currConstructionSite");
			const currConstructionSiteTeamCloseDocument = Shark.get("currConstructionSiteTeamCloseDocument");
	
			folderManager.getByReference(currConstructionSite.siteInfoSheetGuid, "siteInfoSheet")
			.then(getSISFolderResponse => {
				console.log({getSISFolderResponse});
				let projectFolderGuid = "";
	
				if (getSISFolderResponse.data.length > 0) {
					const projectFolder = Utils.safp(getSISFolderResponse.data, "type", "siteInfoSheet");
					projectFolderGuid = projectFolder.guid;
				}

				uploadedDocument.set({
					["extraData.lotId"]: currConstructionSite.__lotId,
					folderGuid: projectFolderGuid,
					role: "fiscalClosingDocument",
					source: "constructionSite"
				});

				if (currConstructionSiteTeamCloseDocument) {
					currConstructionSiteTeamCloseDocument.set({
						document: uploadedDocument,
						fileName: uploadedDocument.name + "." + uploadedDocument.fileType,
					});
				}
				console.log({currConstructionSite, currConstructionSiteTeamCloseDocument, uploadedDocument});
				waitBoxComponent.hide();
			});
		});
	}
}

const constructionSiteActionsComponent = new ConstructionSiteActionsComponent("constructionSiteActionsComponent");

Shark.registerComponent(constructionSiteActionsComponent);

export { constructionSiteActionsComponent };
